<script lang="ts">
    import { apiBaseOverride } from "../../store"
    import ThumbnailSlides from "../ThumbnailSlides.svelte"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let block: ContentBlockEntry
</script>

<!--
        Hero Slider
        - mit und ohne Kategorie (Dropdown-Feld)
          Kategorien: orienteering, mtb-enduro, school-sports, other-sports
        - Muss als Slider funktionieren! (Svelte)
        - Bild links oder Bild rechts (entscheidbar über Dropdown)
        
    -->

<ThumbnailSlides {apiBase} slides="{block.thumbnailSlider?.slides}" />
